import React from 'react';
import { Edit } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { MUIBaseEntity, MUITableColumn } from 'components/shared/MUITable';

export interface OptionTableEntity extends MUIBaseEntity {
  inventoryOptionId: string;
  code: string;
  name: string;
  description: string;
  pricingCount: number;
}

export function createOptionsTableColumns({
  onEdit,
}: {
  onEdit: (inventoryOptionId: string) => void;
}): MUITableColumn<OptionTableEntity>[] {
  return [
    {
      header: 'Code',
      renderKey: 'code',
      sortKey: 'code',
    },
    {
      header: 'Name',
      renderKey: 'name',
      sortKey: 'name',
    },
    {
      header: 'Description',
      renderKey: 'description',
      renderCell: ({ description }) => <>{description || '-'}</>,
    },
    {
      header: 'Pricing Rules',
      renderKey: 'pricingCount',
      renderCell: ({ pricingCount }) => <>{pricingCount}</>,
    },
    {
      header: 'Actions',
      renderKey: 'inventoryOptionId',
      renderCell: ({ inventoryOptionId }) => (
        <Tooltip title="Edit Option">
          <IconButton
            size="small"
            color="primary"
            className="icon-btn-bordered"
            onClick={event => {
              event.stopPropagation();
              onEdit(inventoryOptionId);
            }}
          >
            <Edit fontSize="small" />
          </IconButton>
        </Tooltip>
      ),
    },
  ];
}
